// Issued identity outlives a draft, restaurant visit, TTL and purchase revision.
// This is a read-only receipt, not payment credentials or permission to replay.
const scope = (account, restaurant) =>
  account != null && restaurant != null
    ? JSON.stringify([String(account), String(restaurant)])
    : null;

export function retainIssuedCheckout(records, checkout) {
  const retained = records || {};
  const key = scope(checkout?.accountId, checkout?.restaurant);
  if (!key) return retained;
  if (checkout.isEnded) {
    if (retained[key]?.id !== checkout.id) return retained;
    const next = { ...retained };
    delete next[key];
    return next;
  }
  if (!checkout.paymentIssued) return retained;
  const fields = [
    'id',
    'accountId',
    'restaurant',
    'ordinaryCheckout',
    'paymentIssued',
    'delivery_revision',
    'total',
    'subtotal',
    'taxes',
    'fees',
    'items',
    'created_at',
    'ttl_seconds',
  ];
  return {
    ...retained,
    [key]: Object.fromEntries(
      fields
        .filter((field) =>
          Object.prototype.hasOwnProperty.call(checkout, field)
        )
        .map((field) => [field, checkout[field]])
    ),
  };
}

export function readIssuedCheckout(state) {
  const key = scope(
    state.main?.user?.id,
    state.restaurant?.selectedRestaurantId
  );
  const checkout = key && state.order?.issuedCheckouts?.[key];
  return checkout?.paymentIssued &&
    !checkout.isEnded &&
    scope(checkout.accountId, checkout.restaurant) === key
    ? checkout
    : null;
}
